import React from "react";
import { Col, Row } from "react-bootstrap";

function Techstack() {
  const techs = [
    { name: "Python", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/python/python-original.svg" },
    { name: "SQL", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/mysql/mysql-original.svg" },
    { name: "Apache Spark", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apache/apache-original.svg" },
    { name: "Kafka", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/apachekafka/apachekafka-original.svg" },
    { name: "Airflow", url: "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/apacheairflow.svg" },
    { name: "dbt", url: "https://raw.githubusercontent.com/dbt-labs/dbt-logo/main/dbt-logo.svg" },
    { name: "Snowflake", url: "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/snowflake.svg" },
    { name: "Docker", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg" },
    { name: "Kubernetes", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/kubernetes/kubernetes-plain.svg" },
    { name: "Terraform", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/terraform/terraform-original.svg" },
    { name: "AWS", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/amazonwebservices/amazonwebservices-original.svg" },
    { name: "Azure", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/azure/azure-original.svg" },
    { name: "GCP", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/googlecloud/googlecloud-original.svg" },
    { name: "Jenkins", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/jenkins/jenkins-original.svg" },
    { name: "Git", url: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg" },
    { name: "Prometheus", url: "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/prometheus.svg" },
    { name: "Grafana", url: "https://raw.githubusercontent.com/simple-icons/simple-icons/develop/icons/grafana.svg" },
  ];

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {techs.map((tech, idx) => (
        <Col key={idx} xs={4} md={2} className="tech-icons">
          <img src={tech.url} alt={tech.name} title={tech.name} style={{ width: "60px", height: "60px" }} />
          <div className="tech-icons-text">{tech.name}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
